import React from "react";
import EmailNotificationsDashboard from "../components/email-notifications/EmailNotificationsDashboard";

const EmailNotificationsContainer = () => <EmailNotificationsDashboard />;
export default EmailNotificationsContainer;
